import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { CircularProgress, Collapse, Divider, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import NoDataList from "../../../../components/NoDataList";
import ProfileCard from "../../../../components/ProfileCard";
import { images } from "../../../../constants/images";
import { MyPublicationsProps } from "../../../../interfaces/components";
import styles from "./entryPoint.module.scss";
import { useProfileRole, useToast } from "../../../../helpers/hooks";
import { addPointsInText, capitalize } from "../../../../helpers/app";
import VisibilityIcon from '@mui/icons-material/Visibility';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import TextFieldShared from "../../../../components/TextField/TextField";
import Filters from "../../../../containers/Profile/MyPublications/Filters/FiltersContainer";
import Chips from "../../../../containers/Profile/MyPublications/Chips/ChipsContainer";
import PauseModal from "../../../../containers/Profile/MyPublications/Management/Pause/PauseContainer";
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Pagination from "../../../../components/Pagination";
import ButtonShared from "../../../../components/Button";
import SaveAltIcon from '@mui/icons-material/SaveAlt';

const EntryPointBrand = ({
    user,
    getMyPublicationsRequest,
    myPublications,
    filterMyPublications,
    cleanFilterMyPublications,
    cleanDataFiltersMyPublications,
    setSearchMyPublications,
    pause,
    dealership,
    setPublicationForNews,
    setDataSheet,
    fetchingReport,
    getPublicationsReport
}: MyPublicationsProps) => {
    const toast = useToast();
    const navigate = useNavigate();
    const profileRole = useProfileRole();
    const params = useParams();
    const location = useLocation();
    const [page, setPage] = useState<number>(1);
    const [loadingPubs, setLoadingPubs] = useState<boolean>(false);
    const [search, setSearch] = useState<string>("");
    const [profile, setProfile] = useState<any>("");
    const [publicationsAux, setPublicationsAux] = useState<any>([]);
    const [onPausePublication, setOnPausePublication] = useState<any>("");
    const [totalPublications, setTotalPublications] = useState<number>(1);
    const [modalPause, setModalPause] = useState<any>({ open: false, publication: "" });
    const [activeTab, setActiveTab] = useState<"used" | "new">("used");
    const [rowData, setRowData] = useState<any>({open: false, item: ""});

    const handlePressRow = (item: any, event?: any) => {
        if (event && event.target.closest('.MuiIconButton-root')) {
            return;
        }
        
        if (dealership?.data?.type === "new") {
            navigate(`/new_cars/edit/${item._id}`);
            setDataSheet([]);
            setPublicationForNews(item);
            return;
        }
        navigate(`/profile/my_publications_brand/${item?._id}/management`);
    }
    const findPicture = (pictures: StockPicture[]) => {
        let defaultPath = pictures[0].pictures[0].path;
        pictures.find((pic) => {
            if (pic._id === "background") {
                defaultPath = pic.pictures[0].path;
                return;
            }
        })
        return defaultPath;
    }

    const handleChangeSearch = (value: any) => {
        value = value.toLowerCase();
        setSearch(value)
    }

    const handleEnterSearch = () => {
        setLoadingPubs(true);
        setSearchMyPublications(search);
    }

    const onSettings = (item: any, event: any) => {
        event.stopPropagation();
        if (dealership?.data?.type === "new") {
            setPublicationForNews(item);
            setDataSheet([]);
            navigate(`/new_cars/edit/${item._id}`);
            return;
        }
        navigate(`/profile/my_publications_brand/${item?._id}/detail`);
    }

    const onPause = (event: React.MouseEvent<HTMLButtonElement>, item: any) => {
        event.stopPropagation();
        setModalPause({ open: true, publication: item });
    }

    const handlePublicationsReport = () => {
        getPublicationsReport('', '', activeTab)
    }

    useEffect(() => {
        if (pause?.fetching === "success") {
            getMyPublicationsRequest(user?.brand, page, 20)
        }
    }, [pause?.fetching]);

    useEffect(() => {
        if (!myPublications?.filters?.text.length) {
            handleChangeSearch("")
        }
    }, [myPublications?.filters?.text]);

    useEffect(() => {
        if (myPublications?.filters?.fetching === "failure") {
            toast("Ha ocurrido un error al mostrar las publicaciones");
        }
        if (myPublications?.filters?.fetching === "success") {
            const filteredPublications = myPublications?.filters?.data?.filter((publication: { condition: string }) => 
                publication.condition === activeTab
            );
            setPublicationsAux(filteredPublications);
            cleanFilterMyPublications();
            setLoadingPubs(false);
        }
    }, [myPublications?.filters?.fetching]);

    useEffect(() => {
        if (myPublications?.fetching === "loading" && publicationsAux?.length > 0) {
            setLoadingPubs(true);
        }
    
        if (myPublications?.fetching === "failure") {
            toast("Ha ocurrido un error al mostrar las publicaciones");
        }
    
        if (myPublications?.fetching === "success") {
            setPublicationsAux(myPublications?.data || []);
            setTotalPublications(Math.ceil((myPublications?.total || 0) / 20));
            setLoadingPubs(false);
        }
    }, [myPublications?.fetching, activeTab]);

    useEffect(() => {
        if (!!myPublications?.filters.text.length || !!myPublications?.filters.states.length || !!myPublications?.filters.branches.length || !!myPublications?.filters.years.length || !!myPublications?.filters.sellers.length) {
            filterMyPublications(myPublications?.filters, page,20,activeTab);
            setLoadingPubs(true);
        } else {
            getMyPublicationsRequest(user?.brand, page, 20);
            setLoadingPubs(true);
        }
    }, [location, page, myPublications?.filters?.text, myPublications?.filters?.states, myPublications?.filters?.branches, myPublications?.filters?.years, myPublications?.filters?.sellers]);

    useEffect(() => {
        setProfile(profileRole(user?.profile?.code));
        cleanDataFiltersMyPublications();
        setActiveTab("used");
    }, []);

    useEffect(() => {
        getMyPublicationsRequest(user?.brand, page, 20);
    }, [activeTab]);

    return (
        params.id
            ?
            <Outlet />
            :
            <>
                <PauseModal
                    open={modalPause?.open}
                    setOpen={() => setModalPause({ ...modalPause, open: false })}
                    loading={pause?.fetching === "loading"}
                    publication={modalPause?.publication}
                />
                {
                    (myPublications?.fetching === "loading" && publicationsAux?.length === 0)
                        ?
                        <div className={styles.loaderPublications} id="loaderPublications">
                            <CircularProgress
                                size={styles.loader}
                                classes={{
                                    colorPrimary: styles.loader
                                }}
                            />
                            <p className={styles.text}>Cargando publicaciones</p>
                        </div>
                        :
                        <ProfileCard>
                            <div className={styles.myPublicationsContainer}>
                                <div className={styles.header}>
                                    <div>
                                         <TextFieldShared
                                        variant="search"
                                        label={dealership?.data?.type !== "new" ? "Buscar por marca o modelo" : "Buscar por modelo o precio"}
                                        name="search"
                                        value={search}
                                        onChange={handleChangeSearch}
                                        className={styles.inputSearch}
                                        onEnter={handleEnterSearch}
                                    />
                                    </div>
                                    <div className={styles.actions}>
                                        <Filters />
                                    {user?.profile?.code.includes("admin") ? <ButtonShared
                                        icon={<SaveAltIcon style={{ marginRight: "4px" }} />}
                                        className={styles.download}
                                        spanClassName={styles.spanDownload}
                                        onPress={handlePublicationsReport}
                                        loading={fetchingReport === "loading"}
                                        title={"Reporte"} /> : null
                                    }
                                    </div>
                                   
                                    
                                </div>
                                <Chips />
                                <div id="publicationsList" className={styles.list}>
                                    {
                                        publicationsAux && publicationsAux.length === 0
                                            ?
                                            <div className={styles.noPublications}>
                                                <NoDataList
                                                    title="No encontramos resultados para tu búsqueda"
                                                    text="Inténtalo de nuevo o prueba utilizando otros filtros"
                                                    image={images.noPublications}
                                                />
                                            </div>
                                            :
                                            <TableContainer className={`${styles.table} ${loadingPubs && styles.loading}`}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow className={styles.head}>
                                                            <TableCell className={styles.cell}>Vehiculo</TableCell>
                                                            <TableCell className={styles.cell}></TableCell>
                                                            <TableCell className={styles.cell}>Precio</TableCell>
                                                            <TableCell className={styles.cell}>{dealership?.data?.type === "new" ? "Stock" : "Estado"}</TableCell>
                                                            <TableCell className={styles.cell}></TableCell>
                                                            <TableCell className={styles.cell}></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {myPublications?.fetching === "loading" ? (
                                                            <TableRow>
                                                                <TableCell colSpan={8} align="center" className={styles.loaderCell}>
                                                                    <div className={styles.loaderPublications}>
                                                                        <CircularProgress
                                                                            size={30}
                                                                            classes={{
                                                                                colorPrimary: styles.loader
                                                                            }}
                                                                        />
                                                                        <p>Cargando publicaciones...</p>
                                                                    </div>
                                                                </TableCell>
                                                            </TableRow>
                                                        ) : (
                                                            publicationsAux?.map((item: any, index: number) => {
                                                                let stateCode = "";
                                                                switch (item?.status_brief?.code) {
                                                                    case "rejected":
                                                                        stateCode = styles.red
                                                                        break;
                                                                    case "payment":
                                                                    case "delivered":
                                                                    case "sold_out":
                                                                        stateCode = styles.green
                                                                        break;
                                                                    case "inspection":
                                                                    case "pending":
                                                                    case "documentation_signature":
                                                                        stateCode = styles.gray
                                                                        break;
                                                                    default:
                                                                        stateCode = styles.blue
                                                                        break;
                                                                }
                                                                return (
                                                                    <>
                                                                        <TableRow 
                                                                            className={styles.row} 
                                                                            onClick={() => setRowData(rowData?.item?._id === item?._id ? {...rowData, open: !rowData?.open} : {item: item, open: rowData?.open ? rowData?.open : !rowData?.open})} 
                                                                            key={index}
                                                                        >
                                                                            <TableCell className={styles.cell}>
                                                                                <div className={`${styles.picture} ${dealership?.data?.type === "new" && styles.pictureNews}`}>
                                                                                    <img src={dealership?.data?.type === "new" ? findPicture(item?.stock[0]?.pictures) : item?.pictures[0]?.path ?? images.noImagePublication} alt={`linzecar linze publication ${item?.title}`} />
                                                                                </div>
                                                                            </TableCell>
                                                                            <TableCell className={`${styles.cell} ${styles.bold} ${styles.ellipsis}`}>
                                                                                <p className={`${styles.text} ${styles.vehicle}`}>{`${item?.title}`}</p>
                                                                            </TableCell>
                                                                           
                                                                            <TableCell className={`${styles.cell} ${styles.bold}`}>
                                                                                <p className={`${styles.text} ${styles.price}`}>$ {addPointsInText(item?.vehicles?.length ? Math.min(...item.vehicles.map((v: any) => v?.price || 0)) : (item?.price || 0))}</p>
                                                                            </TableCell>
                                                                            {dealership?.data?.type === "new" ?
                                                                                <TableCell className={styles.cell}>
                                                                                    <div style={{ display: "flex" }}>
                                                                                        {item.stock.map((current: any) => {
                                                                                            return (
                                                                                                <div data-tooltip={`${current?.name}`} className={styles.stockContainer}>
                                                                                                    <span>{current.quantity}</span>
                                                                                                    <div className={styles.circle} style={{ backgroundColor: current.code }} />
                                                                                                </div>
                                                                                            )
                                                                                        })}
                                                                                    </div>
                                                                                </TableCell> : null}
                                                                            {
                                                                                (dealership?.data?.type !== "new") ?
                                                                                    <TableCell className={styles.cell}>
                                                                                        <div className={`${styles.text}`}></div>
                                                                                    </TableCell>
                                                                                    : null
                                                                            }
                                                                            <TableCell className={styles.cell}>
                                                                                <div className={styles.action}>
                                                                                    {/* {
                                                                                        (item?.status_brief?.code !== "pending" && item?.status_brief?.code !== "rejected") &&
                                                                                        <IconButton title={item?.paused ? "Despausar" : "Pausar"} onClick={(event: any) => onPause(event, item)}>
                                                                                            {
                                                                                                pause?.fetching === "loading" && onPausePublication === item?._id
                                                                                                    ?
                                                                                                    <CircularProgress
                                                                                                        size={styles.loader}
                                                                                                        classes={{
                                                                                                            colorPrimary: styles.loader
                                                                                                        }}
                                                                                                    />
                                                                                                    :
                                                                                                    dealership?.data?.type === "new" ? null : item?.paused
                                                                                                        ?
                                                                                                        <PlayArrowIcon className={styles.icon} />
                                                                                                        :
                                                                                                        <PauseIcon className={styles.icon} />

                                                                                            }
                                                                                        </IconButton>
                                                                                    } */}
                                                                                    <IconButton onClick={(event: any) => onSettings(item, event)}>
                                                                                        <VisibilityIcon className={styles.icon} />
                                                                                    </IconButton>
                                                                                </div>
                                                                            </TableCell>
                                                                            <TableCell className={`${styles.cell} ${styles.action}`}>
                                                                                <IconButton 
                                                                                    title={(rowData?.open && item?._id === rowData?.item?._id) ? "Cerrar" : "Abrir detalles"} 
                                                                                    onClick={(event: any) => {
                                                                                        event.stopPropagation();
                                                                                        setRowData({item: item, open: !rowData?.open});
                                                                                    }}
                                                                                    className={`${styles.arrow} ${rowData?.open && item?._id === rowData?.item?._id && styles.open}`}
                                                                                >
                                                                                    <KeyboardArrowDownIcon className={styles.icon}/>
                                                                                </IconButton>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                        <TableRow>
                                                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                                                                <Collapse in={rowData?.open && item?._id === rowData?.item?._id} timeout="auto" unmountOnExit>
                                                                                    <div className={styles.collapsibleContent}>
                                                                                        {(() => {
                                                                                            const vehicleVersions = item?.vehicles
                                                                                            ?.map((vehicle: any) => ({
                                                                                                name: vehicle?.version,
                                                                                                price: vehicle?.price,
                                                                                                status: vehicle?.active_in_publication ? "Publicado" : "Pausado",
                                                                                                statusCode: vehicle?.active_in_publication ? "active" : "paused"
                                                                                            }))
                                                                                            ?.sort((a: any, b: any) => a.price - b.price);
                                                                                        
                                                                                            
                                                                                            return vehicleVersions.map((version: any, versionIndex: number) => {
                                                                                                let versionStateCode = "";
                                                                                                switch(version.statusCode) {
                                                                                                    case "active":
                                                                                                        versionStateCode = styles.blue;
                                                                                                        break;
                                                                                                    case "paused":
                                                                                                        versionStateCode = styles.gray;
                                                                                                        break;
                                                                                                    case "rejected":
                                                                                                        versionStateCode = styles.red;
                                                                                                        break;
                                                                                                    default:
                                                                                                        versionStateCode = styles.blue;
                                                                                                        break;
                                                                                                }
                                                                                                
                                                                                                return (
                                                                                                    <div key={versionIndex} className={styles.versionRow}>
                                                                                                        <div className={styles.versionCell}></div>
                                                                                                        <div className={styles.versionCell}>{version.name}</div>
                                                                                                        <div className={styles.versionCell}>$ {addPointsInText(version.price)}</div>
                                                                                                        <div className={styles.versionCell}>
                                                                                                            <div className={`${styles.text} ${styles.state} ${versionStateCode}`}>
                                                                                                                {version.status.toUpperCase()}
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className={styles.versionCell}>
                                                                                                            <IconButton
                                                                                                                size="small"
                                                                                                                onClick={(event: any) => {
                                                                                                                    event.stopPropagation();
                                                                                                                  
                                                                                                                }}
                                                                                                                title="Pausar versión"
                                                                                                            >
                                                                                                                <PauseIcon className={styles.icon} />
                                                                                                            </IconButton>
                                                                                                        </div>
                                                                                                        <div className={styles.versionCell}></div>
                                                                                                    </div>
                                                                                                );
                                                                                            });
                                                                                        })()}
                                                                                    </div>
                                                                                </Collapse>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </>
                                                                )
                                                            })
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                    }
                                </div>
                                <Pagination
                                    page={page}
                                    setPage={setPage}
                                    className={styles.pagination}
                                    total={totalPublications}
                                />
                            </div>
                        </ProfileCard>
                }
            </>
    )
};
export default EntryPointBrand;